import type { TNotificationKey } from '@/constants/notifications';

import { NOTIFICATIONS } from '@/constants/notifications';

type TMutationMeta = {
  notify?: TNotificationKey;
  isErrorHandled?: boolean;
};

type TRawMutationMeta = Record<string, unknown> | undefined;

const isNotificationKey = (value: unknown): value is TNotificationKey => typeof value === 'string' && Object.hasOwn(NOTIFICATIONS, value);

const notifyMeta = (notify: TNotificationKey, isErrorHandled?: boolean): TMutationMeta => ({ notify, isErrorHandled });

const readNotifyMeta = (meta: TRawMutationMeta): TMutationMeta => {
  const notify = isNotificationKey(meta?.notify) ? meta.notify : undefined;
  const isErrorHandled = typeof meta?.isErrorHandled === 'boolean' ? meta.isErrorHandled : undefined;

  return { notify, isErrorHandled };
};

export type {
  TMutationMeta,
  TRawMutationMeta,
};
export {
  notifyMeta,
  readNotifyMeta,
};
